import { render, staticRenderFns } from "./dataCenterEle.vue?vue&type=template&id=84860426&scoped=true&"
import script from "./dataCenterEle.vue?vue&type=script&lang=js&"
export * from "./dataCenterEle.vue?vue&type=script&lang=js&"
import style0 from "./dataCenterEle.vue?vue&type=style&index=0&id=84860426&scoped=true&lang=css&"
import style1 from "./dataCenterEle.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84860426",
  null
  
)

export default component.exports